'use client';

import { motion } from 'framer-motion';
import Skeleton from './LoadingSkeleton';

export const PopularEventsLoadingSkeleton = () => {
  return (
    <motion.section 
      className="py-16 bg-gray-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header Skeleton */}
        <div className="text-center mb-12">
          <Skeleton className="h-4 w-16 mx-auto mb-2" />
          <Skeleton className="h-12 w-80 mx-auto" />
        </div>

        {/* Events Carousel Skeleton */}
        <div className="relative">
          {/* Navigation Arrows Skeleton */}
          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10">
            <Skeleton className="w-12 h-12 rounded-full" />
          </div>
          <div className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10">
            <Skeleton className="w-12 h-12 rounded-full" />
          </div>

          {/* Events Grid Skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Generate 3 event card skeletons */}
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full">
                {/* Event Image Skeleton */}
                <Skeleton className="aspect-video w-full" />
                
                {/* Event Content Skeleton */}
                <div className="p-6 flex flex-col flex-grow">
                  {/* Title Skeleton */}
                  <Skeleton className="h-6 w-3/4 mb-3" />
                  
                  {/* Description Skeleton */}
                  <div className="space-y-2 mb-4 flex-grow">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-2/3" />
                  </div>

                  {/* Event Details Skeleton */}
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center">
                      <Skeleton className="w-4 h-4 mr-2" />
                      <Skeleton className="h-4 w-24" />
                    </div>
                    <div className="flex items-center">
                      <Skeleton className="w-4 h-4 mr-2" />
                      <Skeleton className="h-4 w-16" />
                    </div>
                    <div className="flex items-center">
                      <Skeleton className="w-4 h-4 mr-2" />
                      <Skeleton className="h-4 w-32" />
                    </div>
                  </div>

                  {/* Button Skeleton */}
                  <div className="mt-auto">
                    <Skeleton className="h-10 w-full rounded-full" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
};
